const PX_TO_PT_RATIO = 16 / 12;

export const ptToPx = (pt: number) => pt * PX_TO_PT_RATIO;
export const pxToPt = (px: number) => px / PX_TO_PT_RATIO;

export const PT_TO_DPI_RATIO = 300 / 72;

export const ptToDpi = (ptValue: number) => Math.round(ptValue * PT_TO_DPI_RATIO);
